
export function lanchPayBox(){
    setTimeout(()=> document.getElementsByClassName('payboxForm')[0].submit(),1000)
}


